/**
 * Cancel-Intents Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/cancel-intents
 * § 312q BGB-Anträge.
 */

const EMAILS = [
  'max.muster@example.com',
  'erika.weiss@example.de',
  'liam.oconnor@example.com',
  'yuki.tanaka@example.jp',
  'fatima.alhassan@example.com',
  'pieter.vanderberg@example.nl',
  'anneliese.weiss@example.at',
];

const STATUSES = ['pending', 'confirmed', 'cancelled'];
const REASONS = [
  null,
  'zu teuer',
  'wechsele zu Anbieter X',
  'feature fehlt',
  'kurzfristig nicht mehr benötigt',
];

export function cancelIntentsFixture({ search = '', status = '' } = {}) {
  const now = Date.now();
  const all = [];

  for (let i = 0; i < 18; i += 1) {
    const email = EMAILS[i % EMAILS.length];
    const stat = STATUSES[i % STATUSES.length];
    const created = new Date(now - i * 7 * 3_600_000).toISOString();
    const confirmed =
      stat === 'confirmed' ? new Date(now - i * 7 * 3_600_000 + 30 * 60_000).toISOString() : null;
    all.push({
      id: 7000 + i,
      customerEmail: email,
      subscriptionId: 50_000 + i * 7,
      status: stat,
      reason: REASONS[i % REASONS.length],
      createdAt: created,
      confirmedAt: confirmed,
      expiresAt: new Date(now + (14 - i) * 86_400_000).toISOString(),
    });
  }

  const filtered = all.filter((c) => {
    if (search && !c.customerEmail.toLowerCase().includes(search.toLowerCase())) return false;
    if (status && status !== 'all' && c.status !== status) return false;
    return true;
  });

  return { intents: filtered, total: filtered.length };
}
